<template>
  <div class="Flipper"
    :class="{ 'Flipper--isFlipped': isFlipped }"
    @click="activate">

    <div class="Flipper-content">

      <div class="Flipper-front"
        :style="flipperFrontStyle">

        <expander class="Flipper-openButton"
          v-show="!disabled"
          :lock="true" />

      </div>

      <div class="Flipper-back"
        v-if="content">

        <div class="Flipper-backContent">

          <div class="Flipper-backContentHeader t-capsSm"
            v-if="content.title1"
            v-html="content.title1">
          </div>

          <div class="Flipper-backContentBody t-headingXs"
            v-if="content.description1"
            v-html="content.description1">
          </div>

          <expander class="Flipper-closeButton"
            :active="true"
            :lock="true" />

        </div>

      </div>

    </div>

  </div>
</template>

<script>
import Expander from 'components/Expander'

export default {
  name: 'Flipper',

  components: {
    Expander
  },

  props: {
    image: {
      type: String,
      required: true
    },
    content: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isFlipped: false,
      showCloseButton: false
    }
  },

  watch: {
    disabled () {
      if (!this.disabled) return
      this.isFlipped = false
    }
  },

  computed: {
    flipperFrontStyle () {
      return {
        'background-image': `url(${this.image})`
      }
    }
  },

  methods: {
    activate () {
      if (this.disabled) return
      this.isFlipped = !this.isFlipped
    }
  }
}
</script>

<style>
.Flipper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 455px;
  height: 371px;
  perspective: 800px;
}

.Flipper-content {
  width: 349px;
  height: 349px;
  /*outline: 1px solid red;*/
  transform-style: preserve-3d;
  transition: transform 0.5s ease;
  transform: rotateY(0deg);
  will-change: transform;
}

.Flipper--isFlipped .Flipper-content {
  transform: rotateY(180deg);
}

.Flipper-front,
.Flipper-back {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 349px;
  height: 349px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-radius: 50%;
  backface-visibility: hidden;
}

.Flipper-back {
  transform: rotateY(180deg);
  border: 2px solid var(--color-3);
  background-color: var(--color-1);
}

.Flipper-backContent {
  padding: 0 14px;
  text-align: center;
}

.Flipper-backContentHeader {
  color: var(--color-5);
}

.Flipper-backContentHeader + .Flipper-backContentBody {
  margin-top: 0.5rem;
}

.Flipper-closeButton {
  position: absolute;
  right: 0;
  bottom: 20px;
  left: 0;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// Flipper.vue?de80cc3e